import SearchBar from './searchBar';

export interface SelectCountryStoreModel {
    searchBar: SearchBar;
}

class RootStore {
    public searchBar: SearchBar;
    public constructor() {
        this.searchBar = new SearchBar(this);
    }
}

export default new RootStore();
